import isBrowser from './isBrowser';
import getCurrentRoute from './getCurrentRoute';
import getReferralUrl from './getReferralUrl';
import getBrowserResolution from './getBrowserResolution';
import getUserAgent from './getUserAgent';
import getBrowserCookieId from './getBrowserCookieId';

const getBrowserData = async (
  browserCookieIdOverride?: string,
  useReferrerOverride?: boolean,
) => {
  if (!isBrowser) {
    // Return empty data or defaults if not in a browser environment
    return {
      cookieId: null,
      resolution: null,
      referralUrl: null,
      url: null,
      userAgent: null,
    };
  }

  // If in a browser, gather and return all the data
  return {
    cookieId: getBrowserCookieId(browserCookieIdOverride),
    resolution: await getBrowserResolution(),
    referralUrl: await getReferralUrl(useReferrerOverride),
    url: await getCurrentRoute(),
    userAgent: await getUserAgent(),
  };
};

export default getBrowserData;
